import {useCallback, useEffect} from 'react';
import View from './view';
import {useNavigation} from '@react-navigation/native';
import {Screens} from '../../shared/routing';
import {useDispatch, useSelector} from 'react-redux';
import React from 'react';
import {faqSelector} from '../../redux/selectors/resources';
import {getFaq} from '../../redux/actions/resources';
import {profileHolderUscTypeSelector} from '../../redux/selectors/profile';

export const SupportServiceScreen = () => {
  const nav = useNavigation();
  const dispatch = useDispatch();
  const faqQuestions = useSelector(faqSelector());
  const uscType = useSelector(profileHolderUscTypeSelector());
  useEffect(() => {
    if (!faqQuestions) {
      dispatch(getFaq());
    }
  }, [faqQuestions]);

  const handleButtonPress = useCallback(() => {
    nav.navigate(Screens.SupportServiceTopics);
  }, [nav]);

  // if (!faqQuestions) {
  //   return null;
  // }

  return React.createElement(View, {
    questions: faqQuestions,
    uscType,
    onPressTopicsButton: handleButtonPress,
  });
};
